import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getCompleteAddress = createAsyncThunk(
  'addressApi/getCompleteAddress',
  async (participantCep, { getState }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_CLOUD_LOYALTY_ENDPOINT}/cloudloyalty/v1/addresses/${participantCep}`,
      { headers: customHeaders }
    );

    return response;
  });
